/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterSupplierState } from "./type";

const INITIAL_STATE: FilterSupplierState = {
  filters: {
    search: "",
    supplier_name: "",
    cnpj: "",
    supplier_number: "",
    created_at: "",
    meta: {
      page: 1,
      perPage: 10,
    },
  },
};

type FilterKeys = keyof FilterSupplierState["filters"];

const filterSupplierSlice = createSlice({
  name: "filters",
  initialState: INITIAL_STATE,
  reducers: {
    setFilter(state, action: PayloadAction<{ key: FilterKeys; value: any }>) {
      state.filters[action.payload.key] = action.payload.value;
    },
    resetFilters(state) {
      state.filters = INITIAL_STATE.filters;
    },
    setPagination(
      state,
      action: PayloadAction<{ page: number; perPage: number }>
    ) {
      state.filters.meta = action.payload;
    },
  },
});

export const { setFilter, resetFilters, setPagination } =
filterSupplierSlice.actions;
export default filterSupplierSlice.reducer;
